// READ-ONLY MODULE (FNP-969). There is deliberately no sibling `mutations.ts`
// here: openTestRun / closeTestRun / abandonTestRun are @aws_iam and are called
// by the executor canary, not by the console. Do not add one.
//
// The step counts are all selected together. They are individually nullable, and
// a selection that omitted one would render a blank cell that reads as "zero
// steps" rather than "not recorded" — a different and misleading fact.
const TEST_RUN_FIELDS = `
    id
    testDefinitionId
    testCode
    personaId
    syntheticUserId
    startedAt
    completedAt
    status
    stepsTotal
    stepsPassed
    stepsFailed
    stepsSkipped
    leaseExpiresAt
    claimedBy
    created
    updated
`;

export const listTestRuns = `
   query listTestRuns($filter: TestRunsFilterInput, $limit: Int, $nextToken: String) {
       listTestRuns(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              ${TEST_RUN_FIELDS}
           }
           nextToken
       }
   }
`;

export const getTestRun = `
   query getTestRun($id: ID!) {
       getTestRun(id: $id) {
         ${TEST_RUN_FIELDS}
       }
}`;

export const listTestRunsByDefinition = `
   query listTestRunsByDefinition($testDefinitionId: ID!, $limit: Int, $nextToken: String) {
       listTestRunsByDefinition(testDefinitionId: $testDefinitionId, limit: $limit, nextToken: $nextToken) {
           items {
              ${TEST_RUN_FIELDS}
           }
           nextToken
       }
   }
`;
